<div class="contact-dialog-overlay">
  <div class="search-container">
    <!-- Header -->
    <div class="header-row">
      <h2 style="color: white;">Search CRM</h2>
      <button mat-icon-button (click)="dialogRef.close()" [attr.guide]="url + '-close-btn'" class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- Search Section -->
    <div class="search-section">
      <div class="search-bar">
        <mat-icon class="search-icon">search</mat-icon>
        <input cdkFocusInitial #searchInput type="text" (input)="onSearch()" (keyup.enter)="onSearch()"
          [(ngModel)]="searchText" [placeholder]="'Search your ' + placeHolderName"
          [attr.guide]="url + '-search-input'">
      </div>
    </div>

    <!-- Main Content -->
    <div class="detail-page">
      <mat-tab-group #tabGroup (selectedTabChange)="onTabChange($event)" [attr.guide]="url + '-tabs'">
        <mat-tab *ngFor="let tab of searchList; let i = index" [label]="tab.label | titlecase">
          <div class="content-wrapper">
            <!-- Sidebar Filters -->
            <div class="filters-panel">
              <div class="filter-header">
                <strong>Filters</strong>
                <a (click)="clearFilters()" class="clear-link"
                  [attr.guide]="'crm-search-lnk-3' + '__' + sanitizeUrl(url)">Clear all</a>
              </div>

              <mat-form-field appearance="outline" class="filter-field">
                <mat-label>Sales Owner</mat-label>
                <mat-select [(ngModel)]="selectedSalesOwner" [attr.guide]="url + '-sales-owner-filter'">
                  <mat-option *ngFor="let owner of filtereduserTypeList" [value]="owner.entityId">
                    {{ owner.email }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <button mat-flat-button color="primary" class="apply-btn" (click)="applyFilters()"
                [disabled]="!selectedSalesOwner" [attr.guide]="url + '-apply-filters-btn'">Apply Filters</button>
            </div>

            <!-- Results Panel -->
            <div class="results-panel">
              <!-- Loading Spinner -->
              <div class="spinner-wrapper" *ngIf="spinner">
                <mat-spinner [diameter]="32"></mat-spinner>
              </div>

              <!-- Empty State -->
              <div class="no-results" *ngIf="!spinner && (!searchLeadList || searchLeadList.length === 0) 
                  && (!searchCompanyList || searchCompanyList.length === 0) 
                   && (!searchDealsList || searchDealsList.length === 0) 
                   && (!leadActivityList || leadActivityList.length === 0) 
                    && (!googleCalendarList || googleCalendarList.length === 0)">
                <mat-icon>search_off</mat-icon>
                <p>No results found for "{{searchText}}"</p>
                <small style="color: #94a3b8; margin-top: 8px;">Try adjusting your filters or search term</small>
              </div>

              <!-- Leads Section -->
              <div class="results-section"
                *ngIf="leadPageEnable && (tab.label === 'All results' || tab.label === 'lead')"
                (scroll)="onScroll($event , 1)">
                <div class="section-header">
                  <h3>Lead <span>({{searchLeadList?.length || 0}})</span></h3>
                  <button class="go-to-btn" mat-stroked-button (click)="goToPage('lead')"
                    *ngIf="searchLeadList && searchLeadList.length > 0"
                    [attr.guide]="'crm-search-btn-5' + '__' + sanitizeUrl(url)">
                    View All
                  </button>
                </div>
                <div class="results-list">
                  <div *ngFor="let lead of searchLeadList; let i = index" class="result-item"
                    (click)="detailPage(lead.entityId)" [attr.guide]="url + '-lead-result-' + i">
                    <div class="avatar">{{ getAvatar(lead.name) }}</div>
                    <div class="content">
                      <div class="name">{{lead.name}}</div>
                      <div class="sub-text">
                        <span><mat-icon style="font-size: 14px; width: 14px; height: 14px;">email</mat-icon>
                          {{lead.email}}</span>
                      </div>
                    </div>
                    <div class="meta">
                      <div class="owner">{{ lead?.ownerEmail?.split('@')[0] }}</div>
                      <div class="time">{{ getDaysAgo(lead.updatedDate) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Accounts Section -->
              <div class="results-section"
                *ngIf="companyPageEnable && (tab.label === 'All results' || tab.label === 'accounts')"
                (scroll)="onScroll($event , 2)">
                <div class="section-header">
                  <h3>Accounts <span>({{searchCompanyList?.length || 0}})</span></h3>
                  <button class="go-to-btn" mat-stroked-button (click)="goToPage('accounts')"
                    *ngIf="searchCompanyList && searchCompanyList.length > 0"
                    [attr.guide]="'crm-search-btn-6' + '__' + sanitizeUrl(url)">
                    View All
                  </button>
                </div>
                <div class="results-list">
                  <div *ngFor="let company of searchCompanyList; let i = index" class="result-item"
                    (click)="companyDetailPage(company.entityId)" [attr.guide]="url + '-company-result-' + i">
                    <div class="avatar">{{getAvatar(company.name)}}</div>
                    <div class="content">
                      <div class="name">{{company.name}}</div>
                      <div class="sub-text">
                        <span><mat-icon style="font-size: 14px; width: 14px; height: 14px;">business</mat-icon>
                          Account</span>
                      </div>
                    </div>
                    <div class="meta">
                      <div class="owner">{{company?.ownerEmail?.split('@')[0] }}</div>
                      <div class="time">{{ getDaysAgo(company.updatedDate) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Deals Section -->
              <div class="results-section"
                *ngIf="dealsPageEnable && (tab.label === 'All results' || tab.label === 'deals')"
                (scroll)="onScroll($event , 3)">
                <div class="section-header">
                  <h3>Deals <span>({{searchDealsList?.length || 0}})</span></h3>
                  <button class="go-to-btn" mat-stroked-button (click)="goToPage('deals')"
                    *ngIf="searchDealsList && searchDealsList.length > 0"
                    [attr.guide]="'crm-search-btn-7' + '__' + sanitizeUrl(url)">
                    View All
                  </button>
                </div>
                <div class="results-list">
                  <div *ngFor="let deal of searchDealsList; let i = index" class="result-item"
                    (click)="dealsDetailPage(deal.entityId, deal.attributeSetId)"
                    [attr.guide]="url + '-deal-result-' + i">
                    <div class="avatar">{{ getAvatar(deal.company || deal.dealsName) }}</div>
                    <div class="content">
                      <div class="name">{{deal.company || deal.dealsName}}</div>
                      <div class="sub-text">
                        <span><mat-icon style="font-size: 14px; width: 14px; height: 14px;">monetization_on</mat-icon>
                          Deal</span>
                      </div>
                    </div>
                    <div class="meta">
                      <div class="owner">{{ deal?.dealsOwner?.split('@')[0] }}</div>
                      <div class="time">{{ getDaysAgo(deal.updatedDate) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tasks Section -->
              <div class="results-section"
                *ngIf="leadActivityPageEnable && (tab.label === 'All results' || tab.label === 'Tasks')"
                (scroll)="onScroll($event , 4)">
                <div class="section-header">
                  <h3>Tasks <span>({{leadActivityList?.length || 0}})</span></h3>
                  <button class="go-to-btn" mat-stroked-button (click)="goToPage('Tasks')"
                    *ngIf="leadActivityList && leadActivityList.length > 0"
                    [attr.guide]="'crm-search-btn-8' + '__' + sanitizeUrl(url)">
                    View All
                  </button>
                </div>
                <div class="results-list">
                  <div *ngFor="let activity of leadActivityList; let i = index" class="result-item"
                    [attr.guide]="url + '-task-result-' + i">
                    <div class="avatar" style="background: #fbbf24;"><mat-icon
                        style="color: white; font-size: 20px;">assignment</mat-icon></div>
                    <div class="content">
                      <div class="name">{{activity.subject}}</div>
                      <div class="sub-text">
                        <span>{{activity.activityType}}</span>
                        <span *ngIf="activity.notes">• {{activity.notes}}</span>
                      </div>
                    </div>
                    <div class="meta">
                      <div class="owner">{{ activity?.owner?.split('@')[0] }}</div>
                      <div class="time">{{ getDaysAgo(activity.updatedDate) }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Meetings Section -->
              <div class="results-section"
                *ngIf="googleCalendarPageEnable && (tab.label === 'All results' || tab.label === 'Meetings')"
                (scroll)="onScroll($event , 5)">
                <div class="section-header">
                  <h3>Meetings <span>({{googleCalendarList?.length || 0}})</span></h3>
                  <button class="go-to-btn" mat-stroked-button (click)="goToPage('Meetings')"
                    *ngIf="googleCalendarList && googleCalendarList.length > 0"
                    [attr.guide]="'crm-search-btn-9' + '__' + sanitizeUrl(url)">
                    View All
                  </button>
                </div>
                <div class="results-list">
                  <div *ngFor="let meet of googleCalendarList; let i = index" class="result-item"
                    (click)="meetingDetailPage(meet.googleCalenderId)" [attr.guide]="url + '-meeting-result-' + i">
                    <div class="avatar" style="background: #10b981;">{{ getAvatar(meet.summary) }}</div>
                    <div class="content">
                      <div class="name">{{meet.summary}}</div>
                      <div class="sub-text">
                        <span><mat-icon style="font-size: 14px; width: 14px; height: 14px;">event</mat-icon>
                          Meeting</span>
                        <span *ngIf="meet.description">• {{meet.description}}</span>
                      </div>
                    </div>
                    <div class="meta">
                      <div class="owner">{{ meet?.createdBy?.split('@')[0] }}</div>
                      <div class="time">{{ getDaysAgo(meet.updatedDate) }}</div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>